// Packages
import { useContext, useEffect, useRef, useState } from "react";

// Components
import { Star as StarObject } from "../../Components/Star/Star";

// Logic
import { MapFunctions } from "../../MapFunctions";

// Context
import { LocationsContext } from "../../../LocationsContext";

// Services

// Styles

// Assets

export const Star = ({ location, setCursorPointer }) => {
	const { setIsDisplayingHierarchy, setSelectedLocationId, setHoverMapLocationId } = useContext(LocationsContext);
	const { coordToPosition } = MapFunctions();
	const ref = useRef();
	const [isHovering, setIsHovering] = useState(false);

	function onPointerOver(e, location_id) {
		e.stopPropagation();
		setHoverMapLocationId(location_id);
		setIsHovering(true);
	}

	function onPointerOut(e) {
		e.stopPropagation();
		setHoverMapLocationId(false);
		setIsHovering(false);
	}

	useEffect(() => {
		setCursorPointer(isHovering);
	}, [setCursorPointer, isHovering]);

	function onClickLocation(e, input_location) {
		e.stopPropagation();

		setIsDisplayingHierarchy(true);
		setSelectedLocationId(input_location?._id);
	}

	return (
		<group ref={ref} position={[1, 0, 0]}>
			<StarObject
				position={coordToPosition(location?.position, { order: "yxz", multiplier: 0.05 })}
				scale={1}
				onClick={(e) => onClickLocation(e, location)}
				onPointerOver={onPointerOver}
				onPointerOut={onPointerOut}
			/>
		</group>
	);
};
